import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Room from './pages/Room';
import MediaSelect from './pages/MediaSelect';
import ExportImage from './pages/ExportImage';
import ExportMot from './pages/ExportMot';
import ExportVideo from './pages/ExportVideo';
import ExportDessin from './pages/ExportDessin';
import WaitingState from './pages/WaitingState';
import OnTv from './pages/OnTV';
import Answer from './pages/Answer';
import ExportVote from './pages/ExportVote';
import Restart from './pages/Restart';
import Ready from './pages/Ready';
import Reconnect from './pages/Reconnect';


function App({ ws }) {
  const [userCreated, setUserCreated] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [isConnectionReady, setIsConnectionReady] = useState(false);

  //usePageCheck();

  useEffect(() => {
    ws.onopen = () => {
      setIsConnectionReady(true);
    };

    ws.onclose = () => {
      setIsConnectionReady(false);
    };
  }, [ws]);

useEffect(() => {
  if (isConnectionReady && !userCreated) {
    createOrValidateUser();
  }
}, [isConnectionReady, userCreated, ws]);

const createOrValidateUser = () => {
  let userID = localStorage.getItem('userID');

  if (!userID) {
    userID = generateRandomCode(8);
    localStorage.setItem('userID', userID);
  }

  if (ws && userID) {
    // Envoyer le userID au serveur pour validation
    ws.send('USER' + userID);
    
    // Écouter la réponse du serveur
    const handleServerResponse = (event) => {
      const message = event.data;
      
      switch(message) {
        case 'OK':
          console.log('User accepté:', userID);
          setUserCreated(true);
          setUsersList([...usersList, userID]);
          // Retirer l'écouteur après succès
          ws.removeEventListener('message', handleServerResponse);
          break;
          
        case 'ID already in use':
          console.log('User déjà utilisé, génération d\'un nouveau:', userID);
          // Générer un nouveau userID
          const newUserID = generateRandomCode(8);
          localStorage.setItem('userID', newUserID);
          
          // Réessayer avec le nouveau userID
          ws.send('USER' + newUserID);

          // Retirer l'écouteur après succès
          ws.removeEventListener('message', handleServerResponse);
          break;
          
        default:
          // Laisser passer les autres messages
          break;
      }
    };
    
    // Ajouter l'écouteur temporaire
    ws.addEventListener('message', handleServerResponse);
  }
};

function generateRandomCode(length) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let code = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    code += characters.charAt(randomIndex);
  }

  return code;
}



  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Room ws={ws} />} />
          <Route path="/mediaSelect" element={<MediaSelect ws={ws} />} />
          <Route path="/exportImage" element={<ExportImage ws={ws} />} />
          <Route path="/exportMot" element={<ExportMot ws={ws} />} />
          <Route path="/exportVideo" element={<ExportVideo ws={ws} />} />
          <Route path="/exportDessin" element={<ExportDessin ws={ws} />} />
          <Route path="/waitingstate" element={<WaitingState ws={ws} />} />
          <Route path="/exportVote" element={<ExportVote ws={ws} />} />
          <Route path="/restart" element={<Restart ws={ws} />} />
          <Route path="/onTV" element={<OnTv ws={ws} />} />
          <Route path="/answer" element={<Answer ws={ws} />} />
          <Route path="/ready" element={<Ready ws={ws} />} />
          <Route path="/reconnect" element={<Reconnect ws={ws} />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;

